import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

const alias = "/faq/question-answer";

const getQuestionsList = (params) =>
  ConfigCmsApi.get(alias, {
    params,
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });
const createQuestion = (data) =>
  ConfigCmsApi.post(`${alias}`, data, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

const deleteQuestion = (id) => {
  ConfigCmsApi.delete(`${alias}/${id}`, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });
};
const addImage = (id, file) => {
  const data = new FormData();
  data.append("file", file);
  return ConfigCmsApi.post(`/faq/question-answer/${id}/image`, data, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });
};

const getQuestion = (questionId) =>
  ConfigCmsApi.get(`${alias}/${questionId}`, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

const updateQuestion = (data) =>
  ConfigCmsApi.post(`${alias}`, data, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

export default {
  getQuestionsList,
  createQuestion,
  deleteQuestion,
  addImage,
  getQuestion,
  updateQuestion
};
